class Manager {
  map = {} as {
    [key: string]: any;
  };

  constructor() {}

  getPlayerInstance = (id: string) => {
    return this.map[id];
  };

  setPlayerInstance = (id: string, instance: any) => {
    this.map[id] = instance;
  };

  deleteKey = (key: string) => {
    delete this.map[key];
  };

  keys = () => {
    return Object.keys(this.map);
  };

  mutex = (id : string | number) =>{
    this.keys().forEach(playerId=>{
      if(playerId != id) {
        let player = this.map[playerId];
        if(player) {
          player.pause();
        }
      }
    })
  }
}

const instance = new Manager();
export default instance;
